import { AppTheme } from "@/utils/constants/theme";
import { DEFAULTS } from "@/utils/constants/defaults";
import { ExternalToast, toast } from "sonner";

type ActionToastProps = {
  actionLabel: string;
  onActionClick: () => void;
};

type ToastProps = Omit<
  ExternalToast,
  | "success"
  | "error"
  | "warning"
  | "info"
  | "duration"
  | "style"
  | "actionButtonStyle"
  | "description"
  | "action"
  | "icon"
> & {
  type: "success" | "error" | "warning" | "info";
  title: string;
  description?: string;
  action?: ActionToastProps;
};

const renderActionButtonTheme: Record<ToastProps["type"], string> = {
  success: AppTheme.darkSage,
  error: AppTheme.roseMadder,
  warning: AppTheme.butterScotch,
  info: AppTheme.darkMidnigthBlue,
};

export const useToast = () => {
  const onShowToast = ({
    type,
    title,
    description,
    action,
    position = "bottom-right",
    ...rest
  }: ToastProps) => {
    toast[type](title, {
      richColors: true,
      duration: DEFAULTS.toastDuration,
      position,
      style: {
        fontSize: DEFAULTS.toastFontSize,
        columnGap: DEFAULTS.toastContentColGap,
        minWidth: DEFAULTS.toastContainerMinWidth,
      },
      actionButtonStyle: {
        backgroundColor: renderActionButtonTheme[type],
        padding: DEFAULTS.toastPadding,
        fontSize: DEFAULTS.toastActionFontSize,
      },
      description,
      ...(action && {
        action: {
          label: action.actionLabel,
          onClick: action.onActionClick,
        },
      }),
      ...rest,
    });
  };

  return { onShowToast };
};
